// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__1ZN0P","namePhoneContainer":"style_namePhoneContainer__l_APF"};